export default __webpack_public_path__ + "static/media/blood.92ac4007.svg";